import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import TruncatedText from '@components/common/TruncatedText/TruncatedText.component'
import {
  buildPatientProfileLocationState,
  buildPatientProfilePath,
} from '@utils/patientProfileNavigation.util'

type DashboardPatientNameLinkProps = {
  patientId: string
  name: string
  className?: string
}

function DashboardPatientNameLink({
  patientId,
  name,
  className,
}: DashboardPatientNameLinkProps): React.ReactElement {
  const location = useLocation()
  const returnTo = `${location.pathname}${location.search}`

  return (
    <Link
      to={buildPatientProfilePath(patientId)}
      state={buildPatientProfileLocationState(returnTo)}
      className={['dst-patient-link', className].filter(Boolean).join(' ')}
      onClick={(event) => event.stopPropagation()}
    >
      <TruncatedText text={name} tooltipHint="See patient profile" />
    </Link>
  )
}

export default DashboardPatientNameLink
